import {FormControl, InputLabel, Select, MenuItem} from '@mui/material';

function DeviceList(props) {

    const devices = props.items;

    const deviceList = devices.map(device => {

        if(device.label !== "")
        return <MenuItem key={device.id} value={device.id} className={props.selectedItem === device.id ? "selected" : "list-item"}>
                    {device.label} &nbsp; <br/><small style={{opacity:0.5}}>Serial: {device.device_serial}</small>
                </MenuItem>
        return <MenuItem key={device.id} value={device.id} className={props.selectedItem === device.id ? "selected" : "list-item"}>
                    {device.device_serial}
                </MenuItem>
    });

    if(props.loadingState){
        return (
            <></>
        )
    }else{
        return (
            <FormControl fullWidth>
                <InputLabel id="control-device-label">Device</InputLabel>
                <Select
                    labelId="control-device-label"
                    id="control-device-select"
                    label="Device"
                    value={props.selectedItem}
                    onChange={props.handleChange}
                    sx={{mb:2}}
                >
                    {deviceList}
                </Select>
            </FormControl>
        );
    }
  }
  

  export default DeviceList;